import React from 'react';
import {
  RichText,
  Field,
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';

type HeaderBannerProps = WithSitecoreContextProps & {
  fields: {
    RichTextField: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

const HeaderBanner = ({ fields }: HeaderBannerProps): React.JSX.Element => {
  return (
    <div className="header-banner-main">
      <RichText field={fields.RichTextField} />
    </div>
  );
};

export default withSitecoreContext()(HeaderBanner);
